import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationModel } from 'src/app/models/notifications.model';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-message-notif',
  standalone: false,
  templateUrl: './message-notif.component.html',
  styleUrl: './message-notif.component.scss'
})
export class MessageNotifComponent {
  destroy$ = new Subject<void>();
  notifications: NotificationModel[] = [];

  constructor(
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.notificationService.getMessages().subscribe((data) => {
      this.notifications = data;
    });
  }

  removeNotification(id: any) {
    this.notifications = this.notifications.filter((item: any) => {
      return item.id !== id;
    })
  }
}
